import ZrUploadImg from "./uploadImg.vue";
export default ZrUploadImg;
